var resizeTimer,
    modalBodyPadding = null;

$(window).on('resize', function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        bLazy.revalidate();

        rEvent.dispatch('Window.doneResizing');
    }, 250);
});

function addOverlay() {
    $('.l-overlay')
        .finish()
        .fadeIn(200);
}
function addOverlayC() {
    $('.c-overlay')
        .finish()
        .fadeIn(200);
    $('body').addClass('body--overlay');
}
function removeOverlay() {
    $('.l-overlay')
        .finish()
        .fadeOut(200);
    $('.c-overlay')
        .finish()
        .fadeOut(200);
    $('body').removeClass('body--overlay');
}

function freezeScroll() {
    var elementsToScroll = $('.js-allow-scroll, .modal');

    elementsToScroll.each(function() {
        var $elem = $(this);

        bodyScrollLock.disableBodyScroll($elem[0]);
    });
}

function unfreezeScroll() {
    bodyScrollLock.clearAllBodyScrollLocks();
}

$('.modal').on('show.bs.modal', function() {
    freezeScroll();
});

$('.modal').on('shown.bs.modal', function() {
    bLazy.revalidate();
});

$('.modal').on('hidden.bs.modal', function() {
    unfreezeScroll();
});

function slideTo($element, offset) {
    if (typeof offset === 'undefined') {
        offset = 0;
    }

    $('html, body').animate(
        {
            scrollTop: $element.offset().top + offset,
        },
        400
    );
}

function checkResolution(query) {
    var active = false;

    if (!query) {
        return true;
    }

    var items = query.split(';');

    for (var i = 0; i < items.length; i++) {
        if ($('.c-var .' + items[i] + '-is-visible').is(':visible')) {
            active = true;
        }
    }

    return active;
}

$('.modal').on('hide.bs.modal', function() {
    modalBodyPadding = parseInt($('body').css('padding-right'));
});

$('.modal').on('hidden.bs.modal', function() {
    if (modalBodyPadding > 0) {
        $('body').css('padding-right', modalBodyPadding);
        modalBodyPadding = 0;
    }

    setTimeout(function() {
        $('body').css('padding-right', '');
    }, 1);
});

function checkNotificationType(elem) {
    var $price_input = $('.watchdog_price'),
        isCheaper = $(elem).val() == 'become_cheaper';

    if (isCheaper) {
        $price_input.slideDown();
    } else {
        $price_input.slideUp();
    }
}

function watchdogModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-form-modal-watchdog').validate({
        rules: {
            notification_price: {
                number: true,
            },
        },
        submitHandler: function(form) {
            $modal
                .find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');
            $('.js-watchdog-error').slideUp(100);
            $('.js-watchdog-success').slideUp(100);

            Form.ajaxPost(
                form,
                function(data) {
                    $modal
                        .find('[type="submit"]')
                        .prop('disabled', false)
                        .removeClass('is-loading');

                    if (!data.status) {
                        $('.js-watchdog-error')
                            .text(data.message)
                            .slideDown(200);
                    } else {
                        $('.js-watchdog-success')
                            .text(data.message)
                            .slideDown(200);
                        $('.js-watchdog-hide').slideUp(200);

                        if (data.count) {
                            $('.js-breadcrumb-watchdog').removeClass('hidden');
                            $('.js-breadcrumb-watchdog')
                                .find('.count')
                                .text(data.count);
                        }
                    }
                },
                'json'
            );
        },
    });

    checkNotificationType($('#notification_type'));

    $('#notification_type').on('change', function() {
        checkNotificationType($(this));
    });
}

function wishlistModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-wishlist-form').validate({
        submitHandler: function(form) {
            $modal
                .find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(
                form,
                function(data) {
                    $modal
                        .find('[type="submit"]')
                        .prop('disabled', false)
                        .removeClass('is-loading');

                    if (!data.status) {
                        $('.js-wishlist-error')
                            .text(data.message)
                            .slideDown(200);
                    } else {
                        $('.js-wishlist-success')
                            .text(data.message)
                            .slideDown(200);
                        $('.js-wishlist-hide').slideUp(200);

                        if (data.count) {
                            $('.js-breadcrumb-wishlist').removeClass('hidden');
                            $('.js-breadcrumb-wishlist')
                                .find('.count')
                                .text(data.count);
                        }
                    }
                },
                'json'
            );
        },
    });

    $('.js-new-wishlist-form').validate({
        submitHandler: function(form) {
            $modal
                .find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(
                form,
                function(data) {
                    $modal
                        .find('[type="submit"]')
                        .prop('disabled', false)
                        .removeClass('is-loading');

                    if (!data.status) {
                        $('.js-wishlist-error')
                            .text(data.message)
                            .slideDown(200);
                    } else {
                        $('.js-wishlist-success')
                            .text(data.message)
                            .slideDown(200);
                        $('.js-wishlist-hide').slideUp(200);

                        if (data.count) {
                            $('.js-breadcrumb-wishlist').removeClass('hidden');
                            $('.js-breadcrumb-wishlist')
                                .find('.count')
                                .text(data.count);
                        }
                    }
                },
                'json'
            );
        },
    });
}

function checkIcdph($elem) {
    var $input = $elem,
        isChecked = $input.is(':checked'),
        $icDphWrapper = $('.js-icdph'),
        $icDph = $icDphWrapper.find('.c-form__input');

    if (isChecked) {
        $icDph
            .prop('required', true)
            .parent()
            .addClass('is-required');
        $icDphWrapper.show();
    } else {
        $icDph
            .prop('required', false)
            .val('')
            .trigger('focus')
            .trigger('blur')
            .parent()
            .removeClass('is-required');
        $icDphWrapper.hide();
    }
}

function resetAllCaptcha() {
    var captchaLength = $('.g-recaptcha').length;
    for (var i = 0; i < captchaLength; i++) grecaptcha.reset(i);
}

$(function() {
    setTimeout(function() {
        bLazy.revalidate();
    }, 250);

    $('[data-tab]').on('click', function(e) {
        bLazy.revalidate();

        setTimeout(function() {
            bLazy.revalidate();
        }, 250);
    });

    $('.js-remote-modal').on('hidden.bs.modal', function() {
        $(this).removeClass('is-loaded');
    });

    $('.t-tip').tooltip();

    /* Beg - Product - scroll to desc */
    $('.js-products-more-scroll').bind('click', function(event) {
        event.preventDefault();

        slideTo($('.js-listing-wrapper'), -50);
    });
    /* End - Product - scroll to desc */

    $('.jsScrollLink').bind('click', function(event) {
        event.preventDefault();

        slideTo($($(this).attr('href')));
    });

    $(document).on('click', '.pager__load', function() {
        $(this).addClass('is-loading');
    });

    /* Beg - Aside nav */
    // mobile nav
    $('.header__menu__btn').bind('click', function(event) {
        event.preventDefault();

        addOverlay();

        $('body').addClass('show-subnav');
        $('.aside--nav').toggleClass('active');
        //$('.l-base').toggleClass('sidelined');

        setTimeout(function() {
            bLazy.revalidate();
        }, 250);
    });

    $('.aside--nav__item > a').bind('click', function(event) {
        if (
            $(this)
                .parents('.aside--nav__item')
                .find('.aside--subnav')
                .size() == 0
        ) {
            return true;
        }

        event.preventDefault();

        $('.aside__title').text($(this).text());
        $(this)
            .parents('.aside__content, .aside--nav')
            .toggleClass('away');
        $(this)
            .siblings('.aside--subnav')
            .toggleClass('active');
        $(this)
            .parents('.aside--subnav')
            .toggleClass('active');

        setTimeout(function() {
            bLazy.revalidate();
        }, 250);
    });

    $('.aside--subnav__back').bind('click', function(event) {
        event.preventDefault();

        $('.aside__title').text($('.aside__title').attr('data-title'));
        $('.aside__content, .aside--nav').removeClass('away');
        $('.aside--subnav').removeClass('active');
    });

    // mobile multiple order
    $('.aside__close, .aside__footer__close, .l-overlay, .c-overlay').bind(
        'click',
        function(event) {
            removeOverlay();

            $('body')
                .removeClass('show-subnav')
                .removeClass('show-search');
            $('.header__links--search .open').removeClass('open');
            $('.header__nav__item.open').removeClass('open');
            $('.aside.active').removeClass('active');
            $('.l-base').removeClass('sidelined');
        }
    );
    /* End - Aside nav */

    // /* Beg - Modal advantages slider */
    // $('#login').on('shown.bs.modal', function() {
    //     if ($('.bx--advantages .bx-wrapper').size() < 1) {
    //         $('.bx--advantages ul').bxSlider({
    //             slideMargin: 0,
    //             controls: false,
    //             autoReload: true,
    //             auto: true,
    //         });
    //     }
    // });
    // /* End - Modal advantages slider */

    /* Beg - Product - scroll to desc */
    $('.product__desc__link').bind('click', function(event) {
        event.preventDefault();

        slideTo($('.product__info__title'));
    });
    /* End - Product - scroll to desc */

    /* Beg - Checkout 1 - selected box */
    $('.cart__choice__box label').bind('click', function(event) {
        $(this)
            .parents('.cart__choice__wrapper')
            .find('.cart__choice__box.selected')
            .removeClass('selected');
        $(this)
            .parents('.cart__choice__box')
            .addClass('selected');
    });
    /* End - Checkout 1 - selected box */

    /* Beg - Accessories - add to cart msg */
    $('.alternate .products__buy, .accessories .products__buy').bind(
        'click',
        function(event) {
            event.preventDefault();

            $('.top-right')
                .notify({
                    message: { text: 'Produkt bol pridaný do košíka.' },
                })
                .show();
        }
    );
    /* End - Accessories - add to cart msg */

    if ($('.quantity-spinner').length) {
        quantity_spinner();
    }

    $('body').on('click', '.js-categories-more', function(e) {
        var $btn = $(this);
        if ($btn.hasClass('v-more')) {
            return;
        }

        e.preventDefault();

        $btn.siblings('.js-categories-item').addClass('is-visible');
        $btn.parent().removeClass('has-more');
        $btn.remove();
    });

    $('body').on('click', '.pager__item:not(.is-disabled) a', function() {
        if ($('.listing.products').length) {
            $('.listing.products')
                .eq(0)
                .slideHere(60);
        }
    });

    if ($('.js-toggle-icdph').length > 0) {
        checkIcdph($('.js-toggle-icdph .c-form__input'));

        $('.js-toggle-icdph .c-form__input').on('change', function() {
            checkIcdph($(this));
        });
    }
});

function resetCustomization(selectOptions) {
    //close ul.clor/ul.size if they were left open and user is not interacting with them anymore
    //remove the .hover class from items if user is interacting with a different one
    selectOptions
        .siblings('[data-type="select"]')
        .removeClass('is-open')
        .end()
        .parents('.cd-single-item')
        .addClass('hover')
        .parent('li')
        .siblings('li')
        .find('.cd-single-item')
        .removeClass('hover')
        .end()
        .find('[data-type="select"]')
        .removeClass('is-open');
}

function quantity_spinner(presents) {
    if (typeof presents === 'undefined') {
        presents = false;
    }

    $('.quantity-spinner').each(function() {
        var maxValue = 1000;

        if ($(this).hasClass('ui-spinner-input')) {
            $(this).spinner('destroy');
        }

        if ($(this).attr('max')) {
            maxValue = $(this).attr('max');

            if (
                $(this).data('stock') &&
                Number($(this).attr('max')) > Number($(this).data('stock'))
            ) {
                maxValue = $(this).data('stock');
            }
        }

        $(this).spinner({
            min: $(this).attr('min') ? $(this).attr('min') : 1,
            max: maxValue,
            step: $(this).data('spinner-step')
                ? $(this).data('spinner-step')
                : 1,
            start: $(this).data('spinner-start')
                ? $(this).data('spinner-start')
                : 1,
            spin: function(event, ui) {
                if (!presents) {
                    $(this)
                        .parents('.input__wrap')
                        .find('.input__wrap__hidden')
                        .val(ui.value)
                        .trigger('change');
                }
            },
            stop: function(event, ui) {
                if (presents) {
                    $(this).trigger('change');
                }
            },
        });
    });
}
